import React from 'react'
import Select from 'react-select'
import {
  maybeConvertArrayOfStringValuesToSelectOptions,
  matchDefaultValueToSelectOptions,
} from './select_helpers'

import './select.css'

const defaultPushEventOnChangeName = 'liveview-react-select-changed'

const LiveSelect = props => {
  const { id, pushEvent } = props
  const options = maybeConvertArrayOfStringValuesToSelectOptions(props.options)
  const defaultValue = matchDefaultValueToSelectOptions(options, props.defaultValue)

  // NOTE: most styles are added using tailwind classes below. However, some
  // styles are also defined in `./select.css`
  const classNames = {
    clearIndicator: _state => 'hover:text-red-500',
    container: _state =>
      'react-select__container py-0.5 px-2 bg-white rounded border border-gray-200 w-full',
    control: _state => '',
    dropdownIndicator: _state => '',
    group: _state => '',
    groupHeading: _state => '',
    indicatorsContainer: _state => 'ml-1.5',
    indicatorSeparator: _state => '',
    input: _state => '',
    loadingIndicator: _state => '',
    loadingMessage: _state => '',
    menu: _state =>
      '-ml-2 -mb-2 mt-2 py-1 px-1 flex gap-y-4 rounded border border-gray-200 bg-white w-full',
    menuList: _state => 'w-full',
    menuPortal: _state => '',
    multiValue: _state => 'group mr-1 py-1 px-1 rounded hover:bg-gray-100',
    multiValueLabel: _state => 'mr-1',
    multiValueRemove: _state => 'text-gray-400 group-hover:text-red-500',
    noOptionsMessage: _state => '',
    option: _state => 'px-1 py-1 w-full rounded hover:bg-gray-100',
    placeholder: _state => '',
    singleValue: _state => '',
    valueContainer: _state => '',
  }

  const handleChange = (values, _event) => {
    if (props.pushEventOnChange) {
      const eventName = props.pushEventOnChangeName || defaultPushEventOnChangeName
      const payload = {
        id,
        values,
      }

      pushEvent(eventName, payload)
    }
  }

  return (
    <Select
      {...props}
      unstyled={true}
      classNames={classNames}
      classNamePrefix="react-select"
      options={options}
      defaultValue={defaultValue}
      onChange={handleChange}
    />
  )
}

export default LiveSelect
